import React from "react";

import DashboardLayout from "@cloudpremise/portal_core/src/themes/mui/examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "@cloudpremise/portal_core/src/themes/mui/examples/Navbars/DashboardNavbar";
import Card from "@mui/material/Card";
import MDBox from "@cloudpremise/portal_core/src/themes/mui/components/MDBox";
import Box from '@mui/material/Box';
import Grid from "@mui/material/Grid";

const Setup = (props) => {
    return (
        <DashboardLayout>
            <DashboardNavbar />
            <MDBox my={3}>
                <Grid container justifyContent="center" alignItems="center">
                    <Grid item xs={12} md={12} lg={12} ml="auto" mr="auto" position="relative">
                        <MDBox component="form" role="form">
                            <Card style={{borderRadius: "xs"}}>
                                <MDBox
                                    variant="contained"
                                    bgColor="transparent"
                                    borderRadius="sm"
                                    coloredShadow="none"
                                    textAlign="left"
                                >
                                    <Box pl="20px" pt={2} sx={{ display: 'flex' }}>
                                        <h3 style={{marginBottom: "15px"}}>Setup Bpm</h3>
                                    </Box>
                                </MDBox>
                            </Card>
                        </MDBox>
                    </Grid>
                </Grid>
            </MDBox>
        </DashboardLayout>
    )
};

export default Setup;